export enum periods {
    WEEKLY= 'weekly',
    QUARTERLY= 'quarterly',
    MONTHLY='monthly',
    YEARLY= 'yearly'
}